import { render, staticRenderFns } from "./stockbind.vue?vue&type=template&id=3bcd8ec4&"
import script from "./stockbind.vue?vue&type=script&lang=js&"
export * from "./stockbind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports